import { Tag } from 'src/interfaces/tag'
import { State } from '../reducers/types'

export const getTags = (state: State): Array<Tag> => state.tag.tags

export const getIsTagsInitialized = (state: State): boolean => state.tag.isTagsInitialized
